export default __webpack_public_path__ + "static/media/load-mountain.6f7c384a.png";